import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { getEvvtimesheetBO, startenddateBo } from '../evvtimesheet.model';
import * as FileSaver from 'file-saver';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class EvvTimesheetListService {

  constructor(private http: HttpClient, public errorService: ErrorService,public toasterService:ToastrService
  ) { }


  GetClientDropDown(): Observable<any> {
    let url = "api/Client/GetClientDropDown?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  Getactivitieslist(params: URLSearchParams): Observable<any> {
    let url = "api/EvvTimesheetAdmin/GetEvvActivities?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  Getsign(params: URLSearchParams): Observable<any> {
    let url = "api/EvvTimesheetAdmin/getsign?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }



  GetAllEmployeesDropdown(): Observable<any> {
    let url = "api/Employee/GetAllEmployeesDropdown?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetAllClientDropDown(): Observable<any> {
    let url = "api/Client/GetAllClientDropDown?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  UpdateRateTimesheet(params: startenddateBo): Observable<any> {
    let url = "api/Visit/UpdateMultipleVisit";
    return this.http.post<any>(url, params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  MoveToArchive(ArchiveList: any[]): Observable<number> {
    let url = "api/Visit/moveToArchive";
    return this.http.post<number>(url, ArchiveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  MoveToActive(ActiveList: any[]): Observable<number> {
    let url = "api/Visit/moveToActive";
    return this.http.post<number>(url, ActiveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  MarkedasApproved(evvtimesheetId): Observable<any> {
    let url = "api/Visit/MarkedasApproved";
    return this.http.post<any>(url, evvtimesheetId, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  MarkedasunApproved(evvtimesheetId): Observable<any> {
    let url = "api/Visit/MarkedasUnApproved";
    return this.http.post<any>(url, evvtimesheetId, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  exportcsv(getBO: getEvvtimesheetBO): Observable<any> {

    let url = "api/Visit/GetVisitReport";

    return this.http.post(url, getBO, { observe: 'response' }).pipe(

      map(data => data.body),
      catchError(this.errorService.handleError))


  }

  saveorUpdateFunctionFileSaver(data, url, saveFileName) {
    return this.http.post(url, data, { responseType: 'blob' }).subscribe((data) => {
        FileSaver.saveAs(data, saveFileName)
    },
    (err: HttpErrorResponse) => {
        console.log(err)
        if (err.status == 400) {
          this.toasterService.error("No Records Found");
        }
      }
    )
}
updateMulitpleVisits(value: any): Observable<any> {
  let url = "api/Visit/BulkVisitUpdate";
  return this.http.post(url, value, { observe: 'response', responseType: 'text' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}



}
